<template>
  <el-dialog :visible.sync="dialogFormVisible" :show-close="false" :close-on-click-modal="false" v-loading="loading">
    <el-form label-position="left" ref="AddActivationCodeForm" :rules="addActivationCodeFormRule"
             label-width="120px" :model="addActivationCodeForm">
      <div style="background: #FFFFFF;text-align: center">
        <em class="el-icon-close dialog-close-manual" v-on:click="dialogFormVisible = false"></em>
        <h1 class="acr-dialog-title">生成兑换码</h1>
        <div class="acr-dialog-form">
          <el-form-item label="归属资产类型" prop="propertyTypeId">
            <el-select v-model="addActivationCodeForm.propertyTypeId" placeholder="请选择归属资产类型">
              <el-option v-for="item in propertyTypeList" :label="item.name" :value="item.id"
                         :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="生成数量" prop="name">
            <el-select v-model="addActivationCodeForm.count" placeholder="请选择生成数量">
              <el-option label="10" :value="10"></el-option>
              <el-option label="50" :value="50"></el-option>
              <el-option label="100" :value="100"></el-option>
            </el-select>
          </el-form-item>
          <el-button style="position: absolute;right: 0" v-on:click="doSubmitAddActivationCode">提交</el-button>
        </div>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>

import AxiosBase from "@/components/axiosBase";
import {Message} from "element-ui";

export default {
  name: "AddActivationCodeDialog",
  data() {
    return {
      loading: false,
      dialogFormVisible: false,
      propertyTypeList: [],
      addActivationCodeForm: {
        propertyTypeId: '',
        count: 0
      },
      addActivationCodeFormRule: {
        propertyTypeId: [
          {required: true, message: '请选择归属资产类型', trigger: 'change'}
        ],
        count: [
          {required: true, message: '请选择生成数量', trigger: 'change'}
        ]
      },
      bufferId: '',
    }
  },
  methods: {
    enterAdd() {
      this.getPropertyTypeList();
    },
    getPropertyTypeList() {
      this.loading = true;
      AxiosBase.axiosGet("/property-ad/get-property-type").then(response => {
        if (response !== 0) {
          this.propertyTypeList = response.data;
          this.loading = false;
        }
      })
    },
    doSubmitAddActivationCode() {
      this.$refs['AddActivationCodeForm'].validate((valid) => {
        if (valid) {
          AxiosBase.axiosPut("/property-ad/add-activation-code", this.addActivationCodeForm).then(response => {
            if (response !== 0) {
              this.$parent.$parent.getActivationCodeData();
              this.$refs['AddActivationCodeForm'].resetFields();
              this.dialogFormVisible = false;
              Message({
                showClose: true,
                message: response.data,
                type: 'success'
              });
            }
          })
        }
      });
    }
  }
}
</script>

